import { Bookmark, NotebookPen } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { useUserData } from "../context/UserDataContext";

export default function EntryActions({ item, onOpenNote, onChanged, labelled = false }) {
  const { user, login } = useAuth();
  const { shortlistIds, notes, toggleShortlist } = useUserData();
  const saved = shortlistIds.has(item.id);
  const hasNote = !!notes[item.id];

  const handleSave = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { login(); return; }
    const isSaved = await toggleShortlist(item.id);
    toast(isSaved ? "Added to your TBR" : "Removed from your TBR");
    onChanged?.();
  };

  const handleNote = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { login(); return; }
    onOpenNote?.(item);
  };

  if (labelled) {
    const base = "inline-flex items-center gap-2.5 font-mono text-xs uppercase tracking-[0.2em] px-5 py-4 border transition-colors";
    return (
      <div className="flex flex-wrap gap-3">
        <button
          onClick={handleSave}
          data-testid={`shortlist-toggle-${item.id}`}
          className={`${base} ${saved ? "border-crimson text-crimson" : "border-line text-vellum-muted hover:border-vellum hover:text-vellum"}`}
        >
          <Bookmark className="w-4 h-4" fill={saved ? "currentColor" : "none"} />
          {saved ? "In your TBR" : "Add to TBR"}
        </button>
        <button
          onClick={handleNote}
          data-testid={`note-open-${item.id}`}
          className={`${base} ${hasNote ? "border-brass text-brass" : "border-line text-vellum-muted hover:border-vellum hover:text-vellum"}`}
        >
          <NotebookPen className="w-4 h-4" />
          {hasNote ? "Edit your note" : "Write a note"}
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-4">
      <button
        onClick={handleSave}
        data-testid={`shortlist-toggle-${item.id}`}
        aria-label={saved ? "Remove from your TBR" : "Add to your TBR"}
        title={saved ? "Remove from your TBR" : "Add to your TBR"}
        className={`transition-colors ${saved ? "text-crimson" : "text-vellum-muted hover:text-vellum"}`}
      >
        <Bookmark className="w-4 h-4" fill={saved ? "currentColor" : "none"} />
      </button>
      <button
        onClick={handleNote}
        data-testid={`note-open-${item.id}`}
        aria-label={hasNote ? "Edit your note" : "Write a note"}
        title={hasNote ? "Edit your note" : "Write a note"}
        className={`transition-colors ${hasNote ? "text-brass" : "text-vellum-muted hover:text-vellum"}`}
      >
        <NotebookPen className="w-4 h-4" />
      </button>
    </div>
  );
}
